import { SearchBar } from '@/components/molecules';
import { Heading } from '@/components/atoms';

interface SearchSectionProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const SearchSection = ({
  searchQuery,
  setSearchQuery,
}: SearchSectionProps) => {
  return (
    <div className="lg:col-span-1">
      <Heading level={2} size="xl" className="mb-4">
        Got questions?
      </Heading>
      <SearchBar
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        placeholder="Search..."
        showFilter={false}
        showExport={false}
      />
    </div>
  );
};
